import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {AuthService} from '../../shared/services/auth.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ThemeService} from '../../shared/services/theme.service';
import {ContactApiService} from '../../../../projects/api/src/contact/contact-api.service';
import {ContactInfo} from '../../../../projects/api/src/contact/contact-info.model';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {environment} from '../../../environments/environment';
import {Oauth2Model} from '../../../../projects/api/src/oauth2/oauth2.model';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {InsparkMessageService} from '@inspark/inspark-components';
import {ConfigureService} from '../../../../projects/common/modules/configure/configure.service';
import {isTwoFactorLoginModel} from '../../../../projects/api/src/authentication/twofactor.model';
import {LocalStorageService} from '../../../../projects/api/src/locale-storage/locale-storage.service';
import {AsyncPipe, JsonPipe, NgClass, NgForOf, NgIf, NgStyle} from '@angular/common';
import {LogoAtommindComponent} from '../../shared/components/logo-atommind/logo-atommind.component';
import {LoginTextInputComponent} from '../../shared/forms/fields/login-text-input/login-text-input.component';
import {
  LoginPasswordInputComponent
} from '../../shared/forms/fields/login-password-input/login-password-input.component';
import {CheckboxComponent} from '../../shared/forms/fields/checkbox/checkbox.component';

interface LoginFormModel {
  username: string;
  password: string;
  remember: boolean;
}

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    LogoAtommindComponent,
    ReactiveFormsModule,
    LoginTextInputComponent,
    JsonPipe,
    AsyncPipe,
    TranslateModule,
    LoginPasswordInputComponent,
    CheckboxComponent,
    NgStyle,
    NgForOf,
    NgIf,
    RouterLink
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormComponent implements OnInit, OnDestroy {
  public loginForm: FormGroup;
  public errorMessage = new EventEmitter<boolean>();
  public isFoucs = false;
  deviceInfo = null;
  isBrowserCompatible = true;
  isUnknownBrowser = false;
  isShowPassword = false;
  loginMessage: string;
  oauth2providers: Oauth2Model[];
  oauth2length = 0;
  OAUTH2LENGTH_MAX = 3;
  refWindow: any;
  hovered = -1;
  /*protected baseUrl = environment.backEndUrlPrefix + '/auth/authorize';*/
  private backUrl = '';
  private contactSubscription;
  private contactInfo: ContactInfo;
  private oauth2key = 'oauth2key';

  constructor(private fb: FormBuilder,
              private router: Router,
              private authService: AuthService,
              private activatedRoute: ActivatedRoute,
              private deviceService: DeviceDetectorService,
              private localStorageApi: LocalStorageService,
              private themeService: ThemeService,
              private translate: TranslateService,
              private messageService: InsparkMessageService,
              private contactService: ContactApiService,
              private ref: ChangeDetectorRef,
              private config: ConfigureService,
  ) {
    this.activatedRoute.data.subscribe(data => {
      this.oauth2providers = [];
      const oauth2IdList = this.localStorageApi.load(true, this.oauth2key);
      if (oauth2IdList && data && data.oauth2list && data.oauth2list.length > 0 && oauth2IdList.length > 0) {
        oauth2IdList.forEach(_t => {
          const provider = data.oauth2list.filter(_o => _o.id === _t);
          if (provider && provider.length === 1) {
            const inx = data.oauth2list.indexOf(provider[0]);
            this.oauth2providers = [...this.oauth2providers, ...provider];
            data.oauth2list.splice(inx, 1);
          }
        });
      }
      this.oauth2providers = [...this.oauth2providers, ...data.oauth2list];
      this.oauth2length = this.oauth2providers ? this.oauth2providers.length : 0;
    });
    this.activatedRoute.queryParams.subscribe(params => {
      this.errorMessage.next(params['error']);
      this.backUrl = params['backurl'];
    });
    const theme = this.localStorageApi.load(true,'theme');
    if (theme !== null) {
      this.themeService.theme.next(this.themeService.themes.find(_theme => _theme.id === Number.parseInt(theme, 10)));
    }
    this.createForm();
    this.deviceInfo = deviceService.getDeviceInfo();
    const browser_version = this.deviceInfo.browser_version.split('.');
    if (typeof browser_version === 'undefined') {
      this.isUnknownBrowser = true;
    } else {
      const browser_info = this.getBrowserVersion(browser_version);
      const browser = ListOfBrowsers.filter((item) =>
        this.deviceInfo.browser !== null
        && this.deviceInfo.browser.toLowerCase() === item.name
      );
      if (typeof browser !== 'undefined' && browser.length === 1) {
        if (browser[0].name === 'chrome') {
          this.isFoucs = true;
        }

        if (typeof browser_info === 'undefined' || browser_info.major < browser[0].minor) {
          this.isBrowserCompatible = false;
        }
      } else {
        this.isUnknownBrowser = true;
      }

    }
  }

  ngOnInit() {
    this.contactSubscription = this.contactService.getContactInfo()
      .subscribe(data => {
        this.contactInfo = data;
        this.setLoginMessage();
        this.ref.markForCheck();
      });
  }

  oauth2orize(item) {
    const url = window.location.origin + '/#!/';
    const paramStr = `?client_uri=${encodeURIComponent(url)}&browserType=${this.deviceService.browser}&browserVersion=${this.deviceService.browser_version}&os=${this.getOsVersion()}&deviceInfo=${this.getDeviceType()}&screenSize=${window.screen.availHeight + ':' + window.screen.availWidth}`;
    console.log(
      `oauth2oriz=${environment.backEndUrlPrefix}/auth/authorize/${item.id}${paramStr}`);
    window.open(`${environment.backEndUrlPrefix}/auth/authorize/${item.id}${paramStr}`, '_self');
  }

  setLoginMessage() {
    this.loginMessage = (this.contactInfo && this.contactInfo.loginMessage
      && this.contactInfo.loginMessage.trim().length > 0) ?
      this.contactInfo.loginMessage : this.translate.instant('Login');
  }

  createForm() {
    const form: LoginFormModel = {
      username: '',
      password: '',
      remember: true,
    };
    this.loginForm = this.fb.group(form as { [p: string]: any });
  }

  onSubmit() {
    const request = this.loginForm.value as LoginFormModel;
    const password = encodeURIComponent(request.password);
    this.authService.loginByCredentials(request.username, password,
      {
        rememberMe: (request.remember ? 1 : 0),
        browserType: this.deviceService.browser,
        browserVersion: this.deviceService.browser_version,
        os: this.getOsVersion(),
        deviceInfo: this.getDeviceType(),
        screenSize: window.screen.availHeight + ':' + window.screen.availWidth
      }).subscribe(async (user) => {

        if (isTwoFactorLoginModel(user)) {
          this.router.navigate(['/', 'login', 'twofactorform'], {queryParams: user});
          return;
        }

        this.authService.completeLogin(user, this.backUrl);
      },
      (response) => response.error && response.error['Message'] && this.errorMessage.next(response.error['Message'])
    );

  }

  ngOnDestroy(): void {
    this.contactSubscription.unsubscribe();
  }

  public keepRecoverUser() {
    this.localStorageApi.save(true,'recoveruser', this.loginForm.value.username);
  }

  public getMedia(url) {
    if (url.indexOf('/') === -1) {
      url = environment.mediaUrl + url;
    } else {
      return url;
    }
    return url;
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
    const oauth2IdList = [];
    this.oauth2providers.forEach(_t => {
      oauth2IdList.push(_t.id);
    });
    this.localStorageApi.save(true, this.oauth2key, JSON.stringify(oauth2IdList));
  }

  private getBrowserVersion(raw) {
    if (raw == null || raw.length === 0) {
      return undefined;
    }
    const pieces = raw.map(piece => parseInt(piece, 10));
    const tmp = pieces[0] + '.' + ((pieces.length > 1) ? pieces[1] : 0);
    return {
      major: parseFloat(tmp),
    };
  }

  private getOsVersion() {
    if (!this.deviceService) {
      return 'undefined';
    }
    const ua = this.deviceService.getDeviceInfo().userAgent;
    const inx0 = ua.indexOf('(');
    if (inx0 === -1) {
      return this.deviceService.getDeviceInfo().os;
    }
    return ua.slice(inx0 + 1, ua.indexOf(')', inx0));
  }

  private getDeviceType() {
    if (!this.deviceService) {
      return 'undefined';
    }
    if (this.deviceService.isDesktop()) {
      return 'Desktop';
    } else if (this.deviceService.isTablet()) {
      return 'Tablet';
    } else if (this.deviceService.isMobile()) {
      return 'Mobile';
    }
    return this.deviceService.device;
  }

  protected shadeColor(color, percent) {
    if (color) {
      let R = parseInt(color.substring(1, 3), 16);
      let G = parseInt(color.substring(3, 5), 16);
      let B = parseInt(color.substring(5, 7), 16);

      // tslint:disable-next-line:radix
      R = parseInt(String(R * (100 + percent) / 100), 16);
      G = parseInt(String(G * (100 + percent) / 100), 16);
      B = parseInt(String(B * (100 + percent) / 100), 16);

      R = (R < 255) ? R : 255;
      G = (G < 255) ? G : 255;
      B = (B < 255) ? B : 255;

      const RR = ((R.toString(16).length === 1) ? '0' + R.toString(16) : R.toString(16));
      const GG = ((G.toString(16).length === 1) ? '0' + G.toString(16) : G.toString(16));
      const BB = ((B.toString(16).length === 1) ? '0' + B.toString(16) : B.toString(16));

      return '#' + RR + GG + BB;
    }
  }
}

export interface BrowserVersion {
  name: string;
  minor: number;
}

export const ListOfBrowsers: BrowserVersion[] = [
  {name: 'chrome', minor: 55},
  {name: 'firefox', minor: 46},
  {name: 'ms-edge', minor: 12},
  {name: 'ie', minor: 12},
  {name: 'safari', minor: 7},
  {name: 'opera', minor: 47},
  {name: 'samsung', minor: 10},
  {name: 'ms-edge-chromium', minor: 40}
];
